var _rect, _path, _path2, _path3, _rect2, _path4, _path5, _path6, _rect3, _path7, _path8, _path9, _rect4, _path10, _path11, _path12, _rect5, _path13, _path14, _path15, _g, _g2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgImageReveal(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 233,
    height: 175,
    viewBox: "0 0 233 175",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 50,
    width: 227,
    height: 16,
    rx: 2,
    fill: "#718095",
    fillOpacity: 0.49
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M86.6481 59H8.33949C6.08508 59 6 59.6716 6 60.5C6 61.3284 6.08508 62 8.33949 62H86.6481C88.9025 62 89 61.3284 89 60.5C89 59.6716 88.9025 59 86.6481 59Z",
    fill: "#D1D5DB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M51.6682 54H7.32477C6.04818 54 6 54.6716 6 55.5C6 56.3284 6.04818 57 7.32477 57H51.6682C52.9448 57 53 56.3284 53 55.5C53 54.6716 52.9448 54 51.6682 54Z",
    fill: "#D1D5DB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M225.405 54H205.592C205.022 54 205 56.0147 205 58.5C205 60.9853 205.022 63 205.592 63H225.405C225.975 63 226 60.9853 226 58.5C226 56.0147 225.975 54 225.405 54Z",
    fill: "#D1D5DB"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 73,
    width: 227,
    height: 16,
    rx: 2,
    fill: "#718095",
    fillOpacity: 0.25
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M86.6481 82H8.33949C6.08508 82 6 82.6716 6 83.5C6 84.3284 6.08508 85 8.33949 85H86.6481C88.9025 85 89 84.3284 89 83.5C89 82.6716 88.9025 82 86.6481 82Z",
    fill: "#D1D5DB",
    fillOpacity: 0.65
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M51.6682 77H7.32477C6.04818 77 6 77.6716 6 78.5C6 79.3284 6.04818 80 7.32477 80H51.6682C52.9448 80 53 79.3284 53 78.5C53 77.6716 52.9448 77 51.6682 77Z",
    fill: "#D1D5DB",
    fillOpacity: 0.65
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M225.405 77H205.592C205.022 77 205 79.0147 205 81.5C205 83.9853 205.022 86 205.592 86H225.405C225.975 86 226 83.9853 226 81.5C226 79.0147 225.975 77 225.405 77Z",
    fill: "#D1D5DB",
    fillOpacity: 0.65
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 96,
    width: 227,
    height: 16,
    rx: 2,
    fill: "#718095",
    fillOpacity: 0.25
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M86.6481 105H8.33949C6.08508 105 6 105.672 6 106.5C6 107.328 6.08508 108 8.33949 108H86.6481C88.9025 108 89 107.328 89 106.5C89 105.672 88.9025 105 86.6481 105Z",
    fill: "#D1D5DB",
    fillOpacity: 0.65
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M51.6682 100H7.32477C6.04818 100 6 100.672 6 101.5C6 102.328 6.04818 103 7.32477 103H51.6682C52.9448 103 53 102.328 53 101.5C53 100.672 52.9448 100 51.6682 100Z",
    fill: "#D1D5DB",
    fillOpacity: 0.65
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M225.405 100H205.592C205.022 100 205 102.015 205 104.5C205 106.985 205.022 109 205.592 109H225.405C225.975 109 226 106.985 226 104.5C226 102.015 225.975 100 225.405 100Z",
    fill: "#D1D5DB",
    fillOpacity: 0.65
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 119,
    width: 227,
    height: 16,
    rx: 2,
    fill: "#718095",
    fillOpacity: 0.25
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M86.6481 128H8.33949C6.08508 128 6 128.672 6 129.5C6 130.328 6.08508 131 8.33949 131H86.6481C88.9025 131 89 130.328 89 129.5C89 128.672 88.9025 128 86.6481 128Z",
    fill: "#D1D5DB",
    fillOpacity: 0.65
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M51.6682 123H7.32477C6.04818 123 6 123.672 6 124.5C6 125.328 6.04818 126 7.32477 126H51.6682C52.9448 126 53 125.328 53 124.5C53 123.672 52.9448 123 51.6682 123Z",
    fill: "#D1D5DB",
    fillOpacity: 0.65
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M225.405 123H205.592C205.022 123 205 125.015 205 127.5C205 129.985 205.022 132 205.592 132H225.405C225.975 132 226 129.985 226 127.5C226 125.015 225.975 123 225.405 123Z",
    fill: "#D1D5DB",
    fillOpacity: 0.65
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 142,
    width: 227,
    height: 16,
    rx: 2,
    fill: "#718095",
    fillOpacity: 0.25
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M86.6481 151H8.33949C6.08508 151 6 151.672 6 152.5C6 153.328 6.08508 154 8.33949 154H86.6481C88.9025 154 89 153.328 89 152.5C89 151.672 88.9025 151 86.6481 151Z",
    fill: "#D1D5DB",
    fillOpacity: 0.65
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M51.6682 146H7.32477C6.04818 146 6 146.672 6 147.5C6 148.328 6.04818 149 7.32477 149H51.6682C52.9448 149 53 148.328 53 147.5C53 146.672 52.9448 146 51.6682 146Z",
    fill: "#D1D5DB",
    fillOpacity: 0.65
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M225.405 146H205.592C205.022 146 205 148.015 205 150.5C205 152.985 205.022 155 205.592 155H225.405C225.975 155 226 152.985 226 150.5C226 148.015 225.975 146 225.405 146Z",
    fill: "#D1D5DB",
    fillOpacity: 0.65
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_2732_606)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 109.448,
    y: 17,
    width: 61.2697,
    height: 77.9796,
    rx: 6,
    transform: "rotate(6.95904 109.448 17)",
    fill: "#F3F6F9",
    fillOpacity: 0.74
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_b_2732_606)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M160.054 95.4484L152.073 80.5612C151.662 79.7947 152.358 78.9051 153.201 79.1196L169.75 83.3303C170.603 83.5475 170.779 84.6825 170.032 85.1482L167.107 86.9698C166.51 87.3417 166.473 88.1976 167.036 88.6192L173.154 93.1985C173.603 93.5341 173.688 94.1724 173.344 94.6141L171.992 96.3472C171.652 96.7828 171.024 96.8604 170.588 96.5205L164.41 91.6983C163.858 91.2673 163.045 91.5229 162.839 92.1924L161.891 95.2701C161.63 96.1191 160.474 96.2313 160.054 95.4484Z",
    fill: "#718095",
    fillOpacity: 0.54
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_2732_606",
    x: 90.5826,
    y: 7.58262,
    width: 89.1014,
    height: 103.664,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 5.05
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_2732_606"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_2732_606",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_b_2732_606",
    x: 140.852,
    y: 67.9869,
    width: 43.8025,
    height: 39.8455,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 5.55
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_2732_606"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_2732_606",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageReveal);
export default __webpack_public_path__ + "static/media/image-reveal.efcef06093417aa1e56dc29ce0b933d1.svg";
export { ForwardRef as ReactComponent };